import { Study, StudyType } from '@/shared/api/protocol-ts/model/dto_study_pb';

export const filterStudiesByType =
  (studyType: StudyType) => (studies: Study[]) =>
    studies.filter((study) => study.Type === studyType);
